import React from "react";

const Slogens = () => {
  return (
    <div
      data-aos="slide-up"
      className=" lg:px-36 lg:mt-0 lg:pb-24 bg-cover flex flex-col justify-center flex-wrap w-screen h-full"
      style={{ fontFamily: "Baloo Bhai 2" }}
    >
      <h1 className="lg:text-center text-[1rem] text-center sm:text-xl lg:text-4xl lg:font-extrabold font-bold text-[#EF4A37] md:text-2xl">
        Inspiring Young Minds, Aspiring Brave Ideas
      </h1>
      <p className="lg:px-2 lg:text-xl text-[#7587A4] lg:text-center lg:my-10 px-2 text-sm text-center mt-4 md:text-lg ">
        Students mind are full of unique ideas and young minds are important for
        a nation's development. Providing opportunities and a platform for youth
        to present their perspectives, opinions, share their ideas is an
        important part of development.
      </p>
      
        <div
          // data-aos="slide-up"
          className=" mx-4 sm:mx-16
          lg:rounded-br-[6rem] lg:rounded-tl-[6rem] mt-4
          bg-[#0345CA] bg-opacity-20  rounded-tl-[2rem] rounded-br-[2rem] sm:rounded-tl-[3rem]  sm:rounded-br-[3rem]
           md:rounded-br-[4rem] md:rounded-tl-[4rem]  "
        >
          <div  className="flex flex-col items-center justify-center  ">
          <img
            className=" lg:mx-8 lg:pt-4 lg:pl-4 pt-2 w-[16rem] sm:w-[22rem]  lg:w-[42rem] md:w-[28rem]  "
            src="https://i.ibb.co/chmKRsg/page2img.png"
            alt="slogen"
          ></img>
          <div className=" text-[#013BBA] lg:grid lg:grid-cols-4 lg:mb-8 lg:place-items-center lg:gap-8 lg:text-xl sm:pb-2 sm:gap-6 sm:text-base md:gap-6 gap-2 md:mx-14  md:text-lg  grid-cols-4 text-[0.7rem] font-bold   flex flex-wrap  ">
            <div className="lg:mr-12">IDEA</div>
            <div className="lg:mr-5">MODERNVATE</div>
            <div>SELECTED</div>
            <div>SUCCESSFUL</div>
          </div>
          </div>
        </div>
      
      <h1
        // data-aos="lg:fade-right"
        className="lg:text-center lg:text-4xl sm:text-xl lg:font-extrabold text-[#013BBA] lg:mt-10 text-[1rem] mt-4 text-xl md:text-2xl text-center font-bold "
      >
        Inspiring Young Minds, Aspiring Brave Ideas
      </h1>

      <p
        // data-aos="fade-left"
        className=" text-[#7587A4] lg:text-2xl lg:text-center lg:my-10 md:text-lg px-2 text-sm text-center mt-4"
      >
        When we put all our efforts and hard work into achieving any goal, the
        result will always be positive. It is the responsibility of Universities
        and Industries to nourish the ideas of Students and enlighten them
        towards their success.
      </p>
      <h1
        // data-aos="fade-down"
        className="text-[#7587A4] lg:text-center lg:text-2xl lg:font-bold md:text-xl mt-4 px-2 text-center"
      >
        “If you cannot do great things, do small things in a great way”
      </h1>
    </div>
  );
};
export default Slogens;
